import {boolean, route, string, union} from 'react-router-typesafe-routes';

export const miscRoutesPath = route({
  children: {
    community: route({
      path: 'community',
    }),
    conference: route({
      path: 'conferences/:conferenceId',
      searchParams: {
        a: union(['1', '0']),
        v: union(['1', '0']),
      },
    }),
    conferenceV2: route({
      path: 'conferences/v2/:conferenceId',
      searchParams: {
        a: union(['1', '0']),
        v: union(['1', '0']),
      },
    }),
    connectStripe: route({
      path: 'connect-stripe',
      searchParams: {
        from: string().defined(),
      },
    }),
    goals: route({
      path: 'goals',
      searchParams: {
        goalId: string(),
      },
      state: {
        ClientGoal: boolean(),
        clientId: string(),
        courseId: string(),
        forCoach: boolean(),
        RateGoals: boolean(),
        subgoalId: string(),
      },
    }),
    googleConnect: route({
      path: 'connect-google',
      searchParams: {
        error: union(['1', '0']),
        success: union(['1', '0']),
      },
    }),
    myCoaches: route({
      path: 'my-coaches',
    }),
    onboarding: route({
      path: 'onboarding',
    }),
    phoneConference: route({
      path: 'conferences/phone/:conferenceId',
    }),
    tutorials: route({
      path: 'tutorials',
    }),
    userProfile: route({
      path: 'profile-page/:userId',
      searchParams: {
        cid: string(),
        fromChat: union(['1', '0']),
        spid: string(),
      },
    }),
    // it fu...ing leshacy route for filling in user profile after registration
    userProfileReg: route({
      path: 'user-profile',
    }),
  },
});
